module.exports = __webpack_public_path__ + "img/presidentialsweet_room_image06.8e2df5a2.jpg";